<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          lg="2"
          class="my-1"
        >
          <b-form-group
            class="mb-0"
          >
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
            />
          </b-form-group>
        </b-col>

        <b-col
          lg="6"
          class="my-1"
        >
          <b-form-group
            label="Filter"
            label-cols-sm="1"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col
          label-cols-sm="2"
          class="my-1"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-modal.modal-center
            variant="primary"
            block
            @click="$router.push('/networks/AddNetwork')"
          >
            + Add Network
          </b-button>
        </b-col>

        <b-col cols="12">
          <b-table
            v-if="items"
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            @row-clicked="onRowClick"
          >
            >
            <template #cell(actions)="data">
              <b-button-group>
                <b-button
                  variant="flat-primary"
                  class="btn-icon"
                >
                  <feather-icon icon="HeartIcon" />
                </b-button>
                <b-button
                  variant="flat-primary"
                  class="btn-icon"
                  @click="showDeleteModal(data)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </b-button-group>
            </template>
            <!---
            <template #cell(status)="data">
              <b-button-group>
                <b-button
                  v-if="data.item.devices.items[0]"
                  variant="success"
                  class="btn-icon"
                  disabled="true"
                >
                  <feather-icon icon="WifiIcon" />
                </b-button>
                <b-button
                  v-if="!data.item.devices.items[0]"
                  variant="danger"
                  class="btn-icon"
                  disabled="true"
                >
                  <feather-icon icon="WifiOffIcon" />
                </b-button>

              </b-button-group>
            </template>
-->
          </b-table>
        </b-col>

        <b-col
          cols="12"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>

import Ripple from 'vue-ripple-directive'
import { API } from 'aws-amplify'
import {
  VBModal,
  BCard,
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  VBToggle,
  BButtonGroup,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as queries from '../../graphql/queries'
import * as mutations from '../../graphql/mutations'

export default {
  components: {
    BCard,
    BTable,

    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BButtonGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      nextId: '',
      perPage: 10,
      pageOptions: [10, 25, 50],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'name', label: 'Device Name', sortable: true },
        { key: 'manufacturerSerialNumber', label: 'Serial Number', sortable: true },
        { key: 'app_eui', label: 'App Eui', sortable: true },
        { key: 'deviceModel.name', label: 'Device Model', sortable: true },
        { key: 'object.name', label: 'Object', sortable: true },
        { key: 'site.name', label: 'Site', sortable: true },
        { key: 'actions', label: 'Actions', sortable: true },
      ],
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  created() {
    this.listDevices()
  },
  methods: {
    triggerToast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      },
      {
        position: 'bottom-right',
      })
    },
    showDeleteModal(data) {
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to delete ${data.item.name}`, {
        title: 'Please Confirm',
        size: 'md',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
      })
        .then(value => {
          if (value === true) {
            this.deleteDevice(data.item.id)
          }
        })
    },
    async deleteDevice(deviceId) {
      // eslint-disable-next-line no-unused-vars
      const deleteDevice = {
        id: deviceId,
      }
      // eslint-disable-next-line no-unused-vars
      await API.graphql({
        query: mutations.deleteDevice,
        variables: {
          input: deleteDevice,
        },
      }).then(response => {
        if (response.error) {
          this.triggerToast(`${response.error}`, 'danger', 'DeleteIcon')
        } else {
          this.triggerToast(`${response.data.deleteDevice.name} deleted`, 'success', 'DeleteIcon')
          this.$router.go()
        }
      })
    },
    async listNetworks() {
      const { currentWorkspace } = JSON.parse(localStorage.getItem('userData'))
      await API.graphql({
        query: queries.listNetworks,
        filter: { workspace: { eq: currentWorkspace } },
      }).then(response => {
        this.items = response.listNetworks.items
      })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowClick(event) {
      window.location.href = `/device/${event.id}`
    },
  },
}
</script>

<style></style>
